import { AfterViewInit, Component, ElementRef, OnInit ,OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import {StoreService} from '../store.service';

@Component({
  selector: 'app-home-work',
  templateUrl: './home-work.component.html',
  styleUrls: ['./home-work.component.css', '../../assets/css/font-size.css'],
})

export class HomeWorkComponent implements OnInit, AfterViewInit , OnDestroy {

  lpmapcId: number; //learningPathMetasApplicationPracticeConstituteId
  projectId: number; //projectId
  learningPathMetaId: number; //能力id
  openFlag: number = 1; //是否隐私提交
  exerciseGroup: any; //作业簿
  exerciseType: number; //练习类型
  isOpenClass: number = 0; //是否公开课
  allQuestionsNumber: number = 1;//题目数量
  currentNumber: number = 1;//当前完成题目数量
  page: string; //页面
  theme: string = 'sight'; //主题
  canSave: boolean = false; //是否可以保存
  isSave: boolean = false;
  clickAble: boolean = true;//防止多次点击
  bodyHeight: string; //答题模块的高度
  postData: any;//提交的答案
  isShowTip: boolean = false;//是都显示提示框
  isCollapse: boolean = true; //是否收拢
  isShowToast: boolean = false; //是否显示toast
  toastType: number; //toast类型
  tipType: string = "";//提示框类型
  errTxt: string; //上传错误提示
  buttonTxt: string; //按钮文案
  pdfList: any;  //pdf列表
  uploadId: string = ''; //查询上传文件条件
  uploadList: any; //上传文件集合
  oldUploadList: any; //之前的上传文件集合
  uploadDisabled: boolean = false; //是否允许上传
  isShowPreview: boolean = false; //是否显示预览
  previewSource: any; //预览源
  isShowLoading: boolean = false; //是否显示loading
  isPopupEnter: boolean = false;
  isWechat: boolean = false; //是否微信
  isShowPopup: boolean = false;
  assetsRoute: string = '../../assets';
  saveError: boolean = false;
  isShowMsg: boolean; //是否显示工具链接提示
  isShowFinishTip: boolean = false;//是否完成题目
  isSlideFinal: boolean = false;//题目是否做完
  isShowBackDesc: boolean = false;//是否展示背景描述
  isNextQuestion: boolean = false;//是否解锁下一题
  checkBoxSelector : any;//多选题选项
  downloadUrl : any;
  headTitle : string ="";
  blankSave : boolean = true;//空保存  false : 不是空保存 true:是空保存
  isNeedCorrect: boolean = true; //试卷是否需要批改 默认需要
  showLoading:boolean = false;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private apiService: ApiService,
    private commonService: CommonService,
    private storeService:StoreService) {
  }

  ngOnInit() {
    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    this.isWechat = this.commonService.isWeiXin();

    $('#userIdContainer').val(localStorage.getItem('userId'));

    this.route.params.subscribe(params => {
      this.lpmapcId = params['lpmapcId'];
      this.projectId = params['projectId'];
      this.learningPathMetaId = params['learningPathMetaId'];
      console.log( this.learningPathMetaId );
    });

    if(this.learningPathMetaId){
      localStorage.setItem("learningPathMetaId",String(this.learningPathMetaId));
    }else{
      localStorage.setItem("learningPathMetaId","");
    }
    localStorage.removeItem("moduleId");

    this.getExerciseDetailAPI(this.lpmapcId).then(result => {
      this.exerciseGroup = result;
      this.isNeedCorrect = this.exerciseGroup.needCorrect === 1;
      // if(this.exerciseGroup.status === 10){
      //   this.commonService.learningPortEventLog({'eventType':'homework_myanswer','eventSubType':'mobile'}).then();
      // }
      this.exerciseType = this.exerciseGroup.homeworkAppendixList.length === 0 ? 1 : 5;
      this.isShowMsg = this.exerciseGroup.terminalType === 1 && this.exerciseGroup.userApplyId;
      this.blankSave = (this.exerciseGroup.userAnswer && this.exerciseGroup.userAnswer !== '') || (this.exerciseGroup.userAppendixList != null && this.exerciseGroup.userAppendixList.length > 0) ? false : true;
      this.allQuestionsNumber = 1;
      this.uploadId = this.exerciseGroup['userAppendixList'] ?
        this.exerciseGroup['userAppendixList'].map((o,i)=>{return o.id}).join("|") : "";
      this.getUploadFileList({
        'homeworkDuplicateId': this.lpmapcId,
        'fileUploadIds': this.uploadId
      }).then(result => {
        this.uploadList = result['newFileList'];
        this.oldUploadList = result['oldFileList'];
        this.uploadDisabled = this.uploadList.length >= 10 || this.exerciseGroup.toolsHomeworkFlag && this.uploadList.length === 1;
        this.showLoading = true;
        this.page = this.exerciseGroup.status == 20? 'finish' : this.exerciseGroup.status == 0 && ((!this.exerciseGroup.backgroundDescription || this.exerciseGroup.backgroundDescription ==null) || (this.uploadList && this.uploadList.length))?'answer' :'list';
      });
      this.pdfList = this.exerciseGroup.homeworkAppendixList ? this.exerciseGroup.homeworkAppendixList:[];
      this.postData = this.formatPostData(this.exerciseGroup);
      this.buttonTxt =  '一共' + this.allQuestionsNumber + '小题，立即作答'
      this.titleText();
    })
  }

  ngAfterViewInit() {
    const self = this;
    this.commonService.initPage({
      'backgroundColor': 'rgba(40,51,130,1)'
    });
    $('body').css('height', 'auto');

    $('#wx-open-wrap').css('left', '-200%');
    // $('#wx-open-wrap').show();
  }

  ngOnDestroy(){
    localStorage.removeItem("exerciseGroup");
    localStorage.removeItem("uploadList");
    localStorage.removeItem("pdfList");
    localStorage.removeItem("uploadId");
    localStorage.removeItem("canSave");
  }

  //背景描述
  backgroundDesc() {
    this.isShowBackDesc = !this.isShowBackDesc;
  }

  /**
   * 设置头部的文本
   */
  titleText(){
    if(this.page === 'list'){
      this.headTitle = "";
    }else if(this.page === 'answer'){
      this.headTitle = this.currentNumber + "/" + this.allQuestionsNumber;
    }
  }

  /**
   * 格式化保存数据
   * @param item  传入的对象
   */
  formatPostData(item: any): any {
    return {
      'homeworkDuplicateId': this.lpmapcId,
      'selector': item.userAnswer,
      'fileUploadIds': this.uploadId,
      'openFlag': this.openFlag,
      'terminalType': 2,
      'status': item.status
    };
  }


  //获取练习册本体的高度
  setBodyHeight(event: number): void {
    this.bodyHeight = event + 'rem';
  }

  /**
   * 进入答题页面
   * @param status:Number  进入答题页面状态（0：立即作答 1：编辑）
   */
  goAnswer(status: number): void {
    this.clickAble = true;
    this.currentNumber = 1;
    this.tipType = "";
    this.getExerciseDetailAPI(this.lpmapcId).then(result => {
      this.exerciseGroup = result;
      this.allQuestionsNumber = 1;
      this.postData = this.formatPostData(this.exerciseGroup);
      this.blankSave = (this.exerciseGroup.userAnswer && this.exerciseGroup.userAnswer !== '') || (this.exerciseGroup.userAppendixList != null && this.exerciseGroup.userAppendixList.length > 0) ? false : true;
      this.pageChangedInit('sight', 'answer', 'rgba(40,51,130,1)','linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
      this.titleText();
    });
  }


  //保存
  saveAnswer(page){
    if(!this.clickAble) return
    this.clickAble = false;
    if(this.blankSave){
      this.clickAble = true;
      return false;
    }else{
      this.postData.status = 10;
      this.exerciseCommitAPI(this.postData, this.exerciseType).then(result => {
        // this.blankSave = true;
        this.clickAble = true;
        if(page === 'list'){
          this.exit();
          return;
        }
        if(this.page === 'answer'){
          this.isShowToast = true;
          this.toastType = 3;
          this.tipType = 'save';
          setTimeout(() => {
            this.isShowToast = false;
          }, 1500);
        }
      }).catch(err => {
        if (err['error']['code'] === 101) {
          this.saveError = true;
          this.isShowToast = true;
          this.toastType = 2;
          this.errTxt = err['error']['msg'];
          this.tipType = "";
          setTimeout(() => {
            this.saveError = false;
            this.clickAble = true;
            this.isShowToast = false;
          }, 1500);
        }
      })

    }


  }

  //提示框继续
  tipsContinue(): void {
    console.log('项目作业数据postData',this.postData);
    console.log('项目作业数据this.exerciseGroup',this.exerciseGroup);
    if(this.postData.status >= 20){
      console.log('该项目作业已提交过',this.postData);
      return;
    }
    if(!this.clickAble) return
    this.clickAble = false;
    if (this.tipType === 'save') {
      this.clickAble = true;
      this.blankSave = false;
      this.saveAnswer('list');
      this.isShowTip = false;
    } else if (this.tipType === 'finish') {
      this.postData.status = 20;
      this.exerciseCommitAPI(this.postData, this.exerciseType).then(result => {
        this.clickAble = true;
        this.isShowTip = false;
        this.isPopupEnter = false;
        this.isShowBackDesc = false;
        this.pageChangedInit('sight', 'finish', 'rgba(246,246,246,1)','linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
        setTimeout(() => {
          this.isShowPopup = false;
          this.commonService.initPage({ 'backgroundColor': 'rgba(246,246,246,1)' });
        }, 100);
      }).catch(err => {
        if (err['error']['code'] === 101) {
          this.saveError = true;
          this.isShowToast = true;
          this.toastType = 2;
          this.errTxt = err['error']['msg'];
          setTimeout(() => {
            this.saveError = false;
            this.clickAble = true;
            this.isShowToast = false;
          }, 1500);
        }
      })
    }
  }


  //获取用户隐私选项
  getUserOpenFlag(event) {
    this.openFlag = event;
  }


  //完成练习题
  finishExercise(tabNum: number): void {
    let path = ['home-work-show',this.lpmapcId];
    if (this.learningPathMetaId) {
      this.router.navigate(path,{queryParams:{learningPathMetaId:this.learningPathMetaId,tabNum:tabNum}});
    } else {
      this.router.navigate(path,{queryParams:{projectId:this.projectId,tabNum:tabNum}});
      // alert('正在施工中...');
      // this.router.navigate(['learning-camp-response'],{queryParams:{'constituteId':this.lpmapcId,'tabNum':tabNum,'responseType':1}}).then();
    }

  }

  //提交答案
  commitAnswer(status): void {
    let that = this;
    let flag = false;
    if(that.exerciseType === 1){
      console.log(that.postData.selector);
      flag = that.postData.selector ? true : false;
    }else if(that.exerciseType === 5){
      flag =that.postData.selector || that.postData.fileUploadIds && that.postData.fileUploadIds!=="" ? true : false;
    }


    if(flag){
      that.tipType = 'finish';
      that.isShowPopup = true;
      setTimeout(() => {
        that.isPopupEnter = true;
      }, 300);
    }else{
      that.isShowToast = true;
      that.toastType = 0;
    }

    setTimeout(() => {
      that.isShowToast = false;
    }, 2000);

    if (that.isWechat && that.isShowPopup) {
     try{
       $('#wx-open-wrap').css('left', '5%');
       let btn = document.getElementById('subscribe-btn');
       btn.addEventListener('success', function (e) {
         $('#wx-open-wrap').css('left', '-200%');
         that.isPopupEnter = false;
         setTimeout(() => {
           that.isShowPopup = false;
           that.tipsContinue();
         }, 100);
       });
       btn.addEventListener('error', function (e) {
         $('#wx-open-wrap').css('left', '-200%');
         that.isPopupEnter = false;
         setTimeout(() => {
           that.isShowPopup = false;
           that.tipsContinue();
         }, 100);
       });
     }catch (e) {
       console.log('error', e.message);
       $('#wx-open-wrap').css('left', '-200%');
       that.isPopupEnter = false;
       setTimeout(() => {
         that.isShowPopup = false;
         that.tipsContinue();
       }, 100);
     }
    }
  }

  //是否可以保存（不能保存不出现弹窗提示，可以保存出现弹窗提示）
  getCanSave(event): void {
    this.canSave = event;
    localStorage.setItem("canSave",JSON.stringify(this.canSave));
  }

  //获取子组件提交的练习答案
  getPostData(event): void {
    this.postData.selector = event.selector;
    this.blankSave = (this.postData.selector !== '' && this.postData.selector!=null) || this.postData.fileUploadIds ? false : true;
    if(event.wordOverrun){//提示文本框输入已达上限
      this.isShowToast = true;
      this.toastType = 4;
      setTimeout(() => {
        this.isShowToast = false;
      }, 2000);
    }
    console.log('获取子组件的答案：'+ JSON.stringify(this.postData));
  }


  //页面切换时初始化背景
  pageChangedInit(theme: string, page: string, initColor: string,backgroundImage: string): void {
    this.theme = theme;
    this.page = page;
    this.commonService.initPage({
      'backgroundColor': initColor,
      'backgroundImage' : backgroundImage
    });
  }


  //返回
  exit() {
    if (this.page === 'list') {
      if (this.tipType !== "finish") {
        this.isShowFinishTip = true;
        this.isShowBackDesc = false;
      } else {
        let link = this.learningPathMetaId ? ['learning-path',this.learningPathMetaId] :['learning-project',this.projectId];
        this.router.navigate(link).then();
      }
    }else if(this.page === 'answer'){
      this.isShowBackDesc = false;
      
        if(this.exerciseType == 5 || this.exerciseType == 1){
          if(this.tipType == '' || this.tipType == 'finish'){
            if(this.postData.selector != this.exerciseGroup.userAnswer){
              this.isShowTip = true;
              this.tipType = 'save';
            }else{
              let link = this.learningPathMetaId ? ['learning-path',this.learningPathMetaId] :['learning-project',this.projectId];
              this.router.navigate(link).then();
            }
          }else if(this.tipType == 'save'){
            this.getExerciseDetailAPI(this.lpmapcId).then(result => {
              this.exerciseGroup = result;
              this.postData = this.formatPostData(this.exerciseGroup);
              this.isShowTip = false;
              this.tipType = '';
              let link = this.learningPathMetaId ? ['learning-path',this.learningPathMetaId] :['learning-project',this.projectId];
              this.router.navigate(link).then();
              })
            }
          }
    }
  }

  //提示框退出
  closeComponentTip() {
    console.log("不保存")
    this.openFlag = 1;
    this.getExerciseDetailAPI(this.lpmapcId).then(result => {
      this.exerciseGroup = result;
      this.isShowTip = false;
      let link = this.learningPathMetaId ? ['learning-path',this.learningPathMetaId] :['learning-project',this.projectId];
      this.router.navigate(link).then();
      this.postData = this.formatPostData(this.exerciseGroup);
      this.titleText();
    });
  }

  unFinishExit() {
    let link = this.learningPathMetaId ? ['learning-path',this.learningPathMetaId] :['learning-project',this.projectId];
    this.router.navigate(link).then();
  }

  continue() {
    this.isShowFinishTip = false;
  }

  /**
   * 关闭私密提交弹出层
   */
  closePopup(): void {
    this.openFlag = 1;
    this.tipType = '';
    this.isPopupEnter = false;
    setTimeout(() => {
      this.isShowPopup = false;
    }, 100);
  }

  /**
   * 预览
   * @param event:Object   子组件传递来的预览对象
   */
  showReview(event): void {
    this.previewSource = event;
    this.isShowPreview = true;
  }

  /**
   * 关闭预览
   */
  closePreview(): void {
    this.isShowPreview = false;
  }

  /**
   * 接受子组件传递过来的需要删除文件的下标并删除该文件
   * @param event: Object   子组件传递来的数据
   */
  deleteUploadFile(event): void {
    this.uploadList = this.uploadList.filter((item, i) => i !== event['index']);
    this.uploadDisabled = this.uploadList.length >= 10;
    let campFileUploadIds = '';
    this.uploadList.forEach((item, i) => {
      campFileUploadIds = i !== this.uploadList.length - 1 ? campFileUploadIds + item['id'] + '|' : campFileUploadIds + item['id'];
    });
    this.postData.status = 10;
    this.postData.fileUploadIds = campFileUploadIds;
    this.exerciseCommitAPI(this.postData, this.exerciseType).then(result => {
      this.uploadId =  this.postData.fileUploadIds;
      // this.uploadId = result['userAppendixList'] ?
      //   result['userAppendixList'].map((o,i)=>{return o.id}).join("|") : "";
      this.blankSave = this.postData.selector && this.postData.selector !== '' ? false : true;
    });
  }


  /**
   * 文件上传
   * @param files: files 上传的文件
   */
  fileUpload(files): void {
    if (navigator.onLine) {
      this.fileUploadAPI({ 'files': files['files'], 'id':this.lpmapcId }).then(result => {
        this.uploadId = this.uploadId === "" ? result.id : this.uploadId + '|' + result.id;
        this.postData.fileUploadIds = this.uploadId;
        console.log('上传文件的id是：' + this.uploadId);
        $(files.el).attr('type', 'file');
      }).then(() => {
        return this.getUploadFileList({
          'homeworkDuplicateId ': this.lpmapcId,
          'fileUploadIds': this.uploadId
        }).then(result => {
          return this.uploadList = result['newFileList'];
        });
      }).then(() => {
        this.oldUploadList = this.oldUploadList ? this.oldUploadList : [];
        this.uploadDisabled = this.uploadList.length >= 10 || this.exerciseGroup.toolsHomeworkFlag && this.uploadList.length === 1;
        this.blankSave = (this.postData.selector !== '' && this.postData.selector!=null) || this.postData.fileUploadIds ? false : true;
      });
    } else {
      this.isShowToast = true;
      this.toastType = 2;
      this.errTxt = '保存失败，请检查你的网络设置';
      setTimeout(() => {
        this.isShowToast = false;
        $('#upload_input').attr('type', 'file');
      }, 2000);
    }

  }

  /**
   * 下载PDF文件
   * @param url: Number PDF's URL
   */
  downloadPDF(url: string): void {
    this.downloadUrl = url;
    window.open(url);
    // window.open('ddilearner/v2/camp/applicationPractice/actualOperation/downloadFile/' + id)
  }


  /**
   * 根据试卷ID获取当前试卷所有小题题目
   * @param lpmapcId: Number  试卷Id
   */
  getExerciseDetailAPI(lpmapcId: number): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/project/homework?homeworkDuplicateId=' + lpmapcId,
    }).toPromise();
  }



  /**
   * 提交答案
   * @param postData: JSONObject 作答数据
   * @param exerciseType: Number 作业类型
   */
  exerciseCommitAPI(postData: any, exerciseType: number): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'data': postData,
      'url': 'ddilearner/v2/user/project/homework/saveAnswers'
    }).toPromise();
  }


  /**
   * 根据第一题选择的选项id获取PDF文件
   * @param postData: JSONObject 选择题选项
   */
  getExercisePdfAPI(postData: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'data': postData,
      'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/getExercisePdf',
    }).toPromise();
  }

  /**
   * 获取上传文件列表
   * @param postData: JSONObject 查询文件条件对象
   */
  getUploadFileList(postData: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'data': postData,
      'url': 'ddilearner/v2/user/project/homework/getHomeworkFileList',
    }).toPromise();
  }

  /**
   * 文件上传
   * @param data: Object 上传文件需要的参数
   */
  fileUploadAPI(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: 'ddilearner/v2/user/project/homework/' + this.lpmapcId + '/fileUpload',
        type: 'POST',
        cache: false,
        data: data['files'],
        processData: false,
        contentType: false,
        headers : {
          'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
          'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
        },
        beforeSend: XMLHttpRequest => {
          this.isShowLoading = true;
        },
        success: res => {
          resolve(res);
          setTimeout(() => {
            this.isShowLoading = false;
            $('#upload_input').attr('type', 'file');
          }, 500);
        },
        error: err => {
          if(err.status === 401 && Number(err.responseJSON.code) === 106){
            this.storeService.notification.notAuthed.next(true);
          }
          this.isShowLoading = false;
          this.isShowToast = true;
          this.toastType = 2;
          this.errTxt = err.status === 413 ? '保存失败，请上传小于10M文件！' : err['responseJSON']['msg'];
          setTimeout(() => {
            this.isShowToast = false;
            $('#upload_input').attr('type', 'file');
          }, 2000);

        }
      });
    });
  }


  /**
   * 删除上传文件
   * @param data: Object 删除文件需要的参数
   */
  deleteUploadFileAPI(data: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/deleteCampUploadFile',
      'data': data
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work.component.ts